import React from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Alert,
  CircularProgress,
} from '@mui/material';

const SettingsIntegrationsTab = ({ useTestApi, onChange, loading, error, success }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        MyData API Environment
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Επιλέξτε το περιβάλλον για την αποστολή τιμολογίων στο MyData:
      </Typography>

      <Box sx={{ mb: 3 }}>
        <FormControlLabel
          control={
            <Switch
              checked={useTestApi}
              onChange={(e) => onChange(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {useTestApi ? 'Development (Dev)' : 'Production (Prod)'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {useTestApi
                  ? 'Χρησιμοποιείται το test API της AADE (mydataapidev.aade.gr)'
                  : 'Χρησιμοποιείται το production API της AADE (mydatapi.aade.gr)'}
              </Typography>
            </Box>
          }
          sx={{ alignItems: 'flex-start', m: 0 }}
        />
      </Box>

      <Alert severity={useTestApi ? 'warning' : 'info'} sx={{ mb: 2 }}>
        <Typography variant="body2">
          <strong>Τρέχουσα επιλογή:</strong> {useTestApi ? 'Development' : 'Production'}
          <br />
          {useTestApi
            ? 'Προσοχή: Τα τιμολόγια θα αποσταλούν στο test environment'
            : 'Τα τιμολόγια θα αποσταλούν στο production environment'}
        </Typography>
      </Alert>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}
    </Box>
  );
};

export default SettingsIntegrationsTab;
